import { render } from "./CeoSection.vue?vue&type=template&id=32e3845e&scoped=true"
import script from "./CeoSection.vue?vue&type=script&lang=js"
export * from "./CeoSection.vue?vue&type=script&lang=js"

import "./CeoSection.vue?vue&type=style&index=0&id=32e3845e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e3845e"]])

export default __exports__